import { render } from "./HustPage.vue?vue&type=template&id=60194ee6"
import script from "./HustPage.vue?vue&type=script&lang=js"
export * from "./HustPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__